export { default as RestaurantButtonKuper } from './RestaurantButtonKuper'
